import React, {memo, useState} from 'react';
import {Button, Col, Container, Form, Row} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
import {loginUser} from '../API/user';
import handwai_logo from '../Design/logo.png';
import {
    hasAccessReport,
    isAdmin,
    isAnalyst,
    isAPPactive,
    isAssistenz,
    isCalculator,
    isHandwaiAssistenz,
    isHandwaiMonteur,
    isHandwaiPerson,
    isHandwaiPL,
    isLVactive,
    isMonteur,
    isPL,
    isSuperAdmin,
    isUploader
} from '../Utils';
import {setAPPstatus, setLVstatus, setRoleSession, setUserOrganisation, setUserSession} from '../Utils/Common';


const btnStyle = {
    backgroundColor: 'var(--handwai-green-color)',
    borderColor: 'var(--handwai-green-color)',
    color: 'var(--handwai-grey-1-color)',
    borderRadius: 0
};


function Login(props) {

    const [em, setUserName] = useState();
    const [pwd, setPassword] = useState();

    let history = useHistory();
    const logoStyle = {
        marginLeft: 20
    };
    localStorage.clear();

    let defaultLandingPage = () => {
        if (isHandwaiPerson()) {
            if (isAnalyst()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE);
            } else if (isSuperAdmin()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE);
            } else if (isHandwaiPL()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE);
            } else if (isHandwaiAssistenz()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE);
            } else if (isHandwaiMonteur()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE);
            } else {
                history.push(process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE);
            }

        } else {
            if (isCalculator() && isLVactive()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE);
            } else if (isPL() && isAPPactive()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE);
            } else if (isUploader() && isLVactive()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN);
            } else if (isAssistenz() && isAPPactive()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE);
            } else if (isMonteur() && isAPPactive()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE);
            } else if (isAdmin()) {
                history.push(process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE);
            } else {
                history.push(process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE);
            }
        }


        // if (isMobileAppUser()) {
        //     //LV product activated user
        //     if (isCalculator()) {
        //         history.push(process.env.REACT_APP_FRONTEND_PATH_DASHBOARD);
        //     } else {
        //         history.push(process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE);
        //     }
        //     window.location.reload();
        // } else {
        //     history.push(process.env.REACT_APP_FRONTEND_PATH_DASHBOARD);
        // }
    };

    const handleSubmit = async e => {
        e.preventDefault();
        try {
            const token = await loginUser({em, pwd});
            if (token.status === 200) {
                setUserSession(token.access_token);
                setRoleSession(token.rol);
                setUserOrganisation(token.org_id)
                setLVstatus(token.lv)
                setAPPstatus(token.app)

                sessionStorage.setItem("userFirstName", token.user_firstname)
                sessionStorage.setItem("userLastName", token.user_lastname)

                let x = (props.location.state !== undefined && props.location.state !== null) ? ('referrer' in props.location.state) : false;
                if (x === false) {
                    defaultLandingPage();
                    window.location.reload();
                } else {
                    let y = location.protocol + '//' + location.host + props.location.state.referrer;
                    let response = await hasAccessReport(y);
                    history.push(props.location.state.referrer, {hasaccess: response.message});
                }

            } else {
                alert(process.env.REACT_APP_BACKEND_INVALIDMSG_LOGINPAGE);
            }

        } catch (err) {
            alert(process.env.REACT_APP_BACKEND_INVALIDMSG_LOGINPAGE);
        }
    };

    return (
        <div>
            <br/>
            <header><img
                alt='Handwai GmbH Company Logo'
                src={handwai_logo}
                width='300'
                height='75'
                style={logoStyle}
            /></header>
            <br/><br/>
            <Row>
                <Col/>
                <Col>

                    <div
                        className='container handwai-dark handwai-text-label-normal'>

                        <Form onSubmit={handleSubmit}>
                            <br/><br/>
                            <Container className='handwai-text-label-main'>
                                <Row>
                                    <Col/>
                                    <Col
                                        className='d-flex justify-content-center'>Anmeldung</Col>
                                    <Col/>
                                </Row>
                            </Container>

                            <br/><br/>
                            <Form.Group controlId='formLoginEmail'>
                                <Form.Label/>
                                <Form.Control className='handwai-input'
                                              type='email'
                                              placeholder='E-Mail Adresse'
                                              onChange={event => setUserName(event.target.value)}/>
                            </Form.Group>
                            <br/>
                            <Form.Group controlId='formLoginPassword'>
                                <Form.Label/>
                                <Form.Control className='handwai-input'
                                              type='password'
                                              placeholder='Passwort'
                                              maxLength='50' autoComplete='on'
                                              onChange={event => setPassword(event.target.value)}/>
                            </Form.Group>
                            <br/>

                            <Row>
                                <Col/>
                                <Col className='text-right'><a
                                    style={{color: 'orange'}}
                                    href={process.env.REACT_APP_FRONTEND_PATH_FORGOTPWD}>Passwort
                                    vergessen?</a> </Col>

                            </Row>
                            <Row>
                                <Col
                                    className='d-flex justify-content-center'><Button
                                    className='handwai-btn-login'
                                    style={btnStyle} type='submit'
                                    size='lg' block>
                                    ANMELDEN
                                </Button></Col>

                            </Row>


                            <br/> <br/>
                        </Form>
                    </div>
                </Col>
                <Col/>
            </Row>
        </div>
    );


    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     let token = {};
    //     try {
    //         if (em === 'demo_mobile-pl1@handwai.com') {
    //             setUserSession('token.access_token');
    //             setRoleSession(['Mobile-Pl']);
    //             setUserOrganisation("ORG001")
    //         } else {
    //             token = await loginUser({em, pwd});
    //
    //             if (token.access_token !== undefined) {
    //                 setUserSession(token.access_token);
    //                 setRoleSession(token.rol);
    //                 setUserOrganisation(token.org_id)
    //             }
    //         }
    //
    //         let x =
    //             props.location.state !== undefined && props.location.state !== null
    //                 ? 'referrer' in props.location.state
    //                 : false;
    //
    //         if (x === false) {
    //             defaultLandingPage();
    //         } else {
    //             let y = location.protocol + '//' + location.host + props.location.state.referrer;
    //             let response = await hasAccessReport(y);
    //             history.push(props.location.state.referrer, {hasaccess: response.message});
    //         }
    //
    //         if (token.message !== undefined) {
    //             alert(process.env.REACT_APP_BACKEND_INVALIDMSG_LOGINPAGE);
    //         }
    //     } catch (err) {
    //         alert(process.env.REACT_APP_BACKEND_INVALIDMSG_LOGINPAGE);
    //     }
    // };


}

export default memo(Login);
